export declare type IncludedTheme = 'light' | 'dark' | 'auto'
